<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Azienda Salvioni</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Come molte altre regioni vinicole non francesi, l'Italia ha beneficiato del calo degli investitori nel settore del vino pregiato
                        per amore di Bordeaux e Borgogna. Come collezionisti esperti cercano bottiglie di valore migliore che
                        offrono una crescita più significativa, è da tempo addio Bordeaux e Ciao Italia. Spunto
                        La Toscana e i suoi vini rossi audaci e minacciosi. Ed entra in Azienda Salvioni, tra le più belle e le più belle
                        collezionabile di tutti loro tutti.
                    </div>

                    <div class="howto-title2">È un affare di famiglia</div>
                    <div class="howto-text">
                        Entrata in viticoltura quasi per caso, l'Azienda Salvioni è considerata uno dei vini toscani più giovani. Nonno Salvioni era un dilettante di vino, un hobbista che si divertiva a fare un ottimo prodotto per i suoi amici e la sua famiglia. Vedere suo padre godere di qualcosa di così tanto portato
                        Giulio Salvioni per esplorare il terroir della sua famiglia, e nel 1989 ha iniziato a produrre la famiglia
                        Brunello per un mercato più ampio. La terza generazione e gli attuali capitani dei Salvioni
                        vigneto sono David, che gestisce i 20 ettari di terreno mentre sua sorella Alessia si occupa delle vendite
                        e commercializzazione. Sotto la loro guida il Salivoni è diventato un vino pregiato riconosciuto a livello internazionale,
                        noto per la superba capacità di età e la (relativa) convenienza dei loro due Montalcino.
                    </div>

                    <div class="howto-title2">Quando due diventano uno</div>
                    <div class="howto-text">
                        Prodotto solo nelle annate migliori, il vino di punta dell'Azienda Salvioni è il Brunello di
                        Montalcino. In annate in cui la vendemmia del Sangiovese non è stata ritenuta sufficientemente buona, il
                        l'intero raccolto andrà al secondo vino, il Rosso di Montalcino. Il Brunello di Montalcino vede
                        36 mesi di affinamento in botti di rovere di Slavonia, mentre il Rosso di Montalcino matura per 12 mesi in
                        botti (botte). Entrambi i vini vengono poi anche affinati in bottiglia fino alla commercializzazione. Tra le 8.000 e le 13.000 bottiglie
                        di Brunello di Montalcino prodotto nelle annate buone, con quotazioni fino ad ora congrue per un vino
                        di questa qualità; tuttavia, quantità così piccole significano una maggiore rarità e le bottiglie non sono facili
                        ha trovato l'allocazione postale. Il 2010 è stato finora l'anno migliore per l'Azienda Salvioni (94 punti da
                        Robert Parker), e il mercato non ha tardato a seguirlo: una crescita del 50% tra il 2017 e il 2019
                        su una sola bottiglia dimostra che questo è un vigneto capace di cose meravigliose.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Azienda Salvioni</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wie viele andere nicht-französische Weinregionen hat Italien vom Rückgang der Investoren für edle Weine profitiert
                        aus Liebe zu Bordeaux und Burgund. Erfahrene Sammler suchen nach Flaschen mit einem besseren Preis-Leistungs-Verhältnis
                        Um ein deutlicheres Wachstum zu bieten, heißt es schon seit einiger Zeit „bye bye Bordeaux“ und „Ciao Italia“. Stichwort
                        Die Toskana und ihre kräftigen, nachdenklichen Rotweine. Und betreten Sie die Azienda Salvioni, eine der besten und angesehensten
                        Sammlerstücke von allen.
                    </div>

                    <div class="howto-title2">Es ist eine Familienangelegenheit</div>
                    <div class="howto-text">
                        Der Azienda Salvioni, der fast zufällig in den Weinbau gelangte, gilt als einer der jüngeren Weine der Toskana. Opa Salvioni war ein begeisterter Weinliebhaber, ein Bastler, der Freude daran hatte, ein hervorragendes Produkt für seine Freunde und Familie herzustellen. Zu sehen, wie sein Vater etwas so sehr genoss, führte dazu
                        Giulio Salvioni, um das Terroir seiner Familie zu erkunden, und begann 1989 mit der Produktion der Familie
                        Brunello für einen breiteren Markt. Die dritte Generation und aktuelle Kapitäne der Salvioni
                        Weinberg ist David, der die 20 Hektar großen Felder bewirtschaftet, während seine Schwester Alessia sich um den Verkauf kümmert
                        und Marketing. Unter ihrer Führung hat sich Salivoni zu einem international anerkannten Spitzenwein entwickelt.
                        bekannt für die hervorragende Alterungsfähigkeit und (relative) Erschwinglichkeit ihrer beiden Montalcinos.
                    </div>

                    <div class="howto-title2">Wenn aus zwei eins wird</div>
                    <div class="howto-text">
                        Der Flaggschiffwein der Azienda Salvioni, der nur in den besten Jahren hergestellt wird, ist der Brunello di
                        Montalcino. In Jahren, in denen die Sangiovese-Traubenernte als nicht gut genug erachtet wurde, wurde die
                        Die gesamte Ernte geht an den Zweitwein, den Rosso di Montalcino. Der Brunello di Montalcino sieht
                        36 Monate Reifung in Fässern aus slawonischer Eiche, während der Rosso di Montalcino 12 Monate darin reift
                        Botti (Fass). Beide Weine reifen anschließend bis zur Veröffentlichung in der Flasche. Zwischen 8.000 und 13.000 Flaschen
                        Brunello di Montalcino, hergestellt in guten Jahren, mit bisher fairen Preisen für einen Wein
                        von dieser Qualität; Solche kleinen Mengen bedeuten jedoch eine erhöhte Seltenheit und Flaschen sind nicht leicht erhältlich
                        Beitragszuordnung gefunden. 2010 war bisher das beste Jahr für Azienda Salvioni (94 Punkte).
                        Robert Parker) und der Markt ist schnell gefolgt: ein Wachstum von 50 % zwischen 2017 und 2019
                        auf einer einzigen Flasche zeigt, dass dies ein Weinberg ist, der zu Wunderbaren fähig ist.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Azienda Salvioni</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Comme beaucoup d'autres régions viticoles non françaises, l'Italie a profité de la chute des investisseurs en vins fins
                        par amour pour Bordeaux et la Bourgogne. Alors que les collectionneurs avertis recherchent des bouteilles de meilleure valeur qui
                        offrent une croissance plus importante, c'est fini Bordeaux et Ciao Italia depuis un moment déjà. Signal
                        La Toscane et ses vins rouges audacieux et maussades. Et entrez Azienda Salvioni, parmi les plus beaux et les plus
                        à collectionner de tous.
                    </div>

                    <div class="howto-title2">C'est une affaire de famille</div>
                    <div class="howto-text">
                        Entré dans la viticulture presque par accident, Azienda Salvioni est considéré comme l'un des vins les plus jeunes de la Toscane. Grand-père Salvioni était un amateur de vin, un amateur qui aimerait fabriquer un excellent produit pour ses amis et sa famille. Voir son père profiter de quelque chose de tellement conduit
                        Giulio Salvioni pour explorer le terroir de sa famille, et en 1989, il a commencé à produire la famille
                        Brunello pour un marché plus large. La troisième génération et les capitaines actuels des Salvioni
                        vignoble sont David, qui gère les champs de 20 hectares tandis que sa sœur Alessia gère les ventes
                        et commercialisation. Sous leur direction, Salivoni est devenu un grand vin reconnu internationalement,
                        connu pour la superbe capacité d'âge et l'abordabilité (relative) de leurs deux Montalcinos.
                    </div>

                    <div class="howto-title2">Quand deux deviennent un</div>
                    <div class="howto-text">
                        Produit uniquement les meilleures années, le vin phare d'Azienda Salvioni est son Brunello di
                        Montalcino. Les années où les vendanges de Sangiovese n'ont pas été jugées assez bonnes, la
                        toute la récolte ira au second vin, le Rosso di Montalcino. Le Brunello di Montalcino voit
                        36 mois de vieillissement en fûts de chêne de Slavonie, tandis que le Rosso di Montalcino vieillit pendant 12 mois en
                        botti (fût). Les deux vins sont également ensuite élevés en bouteille jusqu'à leur mise en vente. Entre 8 000 et 13 000 bouteilles
                        de Brunello di Montalcino produit dans les bonnes années, avec des prix jusqu'à présent restant justes pour un vin
                        de cette qualité; cependant, de si petites quantités signifient une rareté accrue et les bouteilles ne sont pas facilement
                        affectation de poste trouvée. 2010 a été jusqu'à présent la meilleure année pour Azienda Salvioni (94 points de
                        Robert Parker), et le marché n'a pas tardé à suivre : une croissance de 50% entre 2017 et 2019
                        sur une seule bouteille montre que c'est un vignoble capable de merveilles.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Azienda Salvioni</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Like many other non-French wine regions, Italy has benefitted from fine wine investors falling
                        out of love with Bordeaux and Burgundy. As savvy collectors look for better value bottles that
                        offer more significant growth, it’s been bye bye Bordeaux and Ciao Italia for some time now. Cue
                        Tuscany and its bold, brooding, red wines. And enter Azienda Salvioni, among the finest and most
                        collectable of all them all.
                    </div>

                    <div class="howto-title2">It’s a family affair</div>
                    <div class="howto-text">
                        Coming into viticulture almost by accident, Azienda Salvioni is considered one of Tuscany’s younger wines. Grandpa Salvioni was a dabbler with wine, a hobbyist who would enjoy making an excellent product for his friends and family. Seeing his father enjoy something so much led
                        Giulio Salvioni to explore his family’s terroir, and in 1989 he began producing the family
                        Brunello for a broader market. The third generation and current captains of the Salvioni
                        vineyard are David, who manages the 20-hectares fields while his sister Alessia manages sales
                        and marketing. Under their steerage Salivoni has become an internationally recognised fine wine,
                        known for the superb age-ability and (relative) affordability of their two Montalcinos.
                    </div>

                    <div class="howto-title2">When two become one</div>
                    <div class="howto-text">
                        Produced in only the best years, Azienda Salvioni’s flagship wine is their Brunello di
                        Montalcino. In years when the Sangiovese grape harvest has not been deemed good enough, the
                        entire crop will go to the second wine, the Rosso di Montalcino. The Brunello di Montalcino sees
                        36 months ageing in Slavonian oak barrels, whereas the Rosso di Montalcino ages for 12 months in
                        botti (cask). Both wines are also then aged in bottle until release. Between 8,000-13,000 bottle
                        of Brunello di Montalcino produced in good years, with prices so far remaining fair for a wine
                        of this quality; however, such small quantities mean increased rarity and bottles are not easily
                        found post allocation. 2010 has so far been the best year for Azienda Salvioni (94 points from
                        Robert Parker), and the market has been quick to follow: a growth of 50% between 2017 and 2019
                        on a single bottle shows that this is a vineyard capable of marvellous things.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AziendaSalvioni",
    head: {
        title: 'Azienda Salvioni | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional taste of Azienda Salvioni wine, crafted in the heart of Tuscany using traditional winemaking techniques and the finest local grapes. Experience the rich, complex flavors and aromas of this renowned wine producer.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
